import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import Root from '/containers/Root';
import theme from './theme';
import { initializeApp } from '/actions/initializeApp';
import { configureAuth } from 'actions/configure-auth';
import { Provider as ReduxProvider } from 'react-redux';
import { configureStore } from '/utils/store';

const store = configureStore();
window.store = store;
store.dispatch(initializeApp());
store.dispatch(configureAuth(
  { apiUrl: process.env.AMAZY_BASE_URL },
  { clientOnly: true }
));

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <ReduxProvider store={store}>
      <Root />
    </ReduxProvider>
  </MuiThemeProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js